import { Button, Upload } from "antd";
import { useRef, useState } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { MdOutlineFileUpload } from "react-icons/md";
import { error } from "../../contants/snackbars";
import { colorScheme } from "../../contants/variables";
import { postVideo, uploadFile } from "../../stores/api_calls/upload";

const CustomVideoUploader = ({ videoUrl, handelVideoChange }) => {
  const [videoFile, setVideoFile] = useState([]);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const generateThumbnail = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject("Failed to generate thumbnail. File not found.");
      }

      const url = URL.createObjectURL(file);
      const video = videoRef.current;

      video.src = url;
      video.muted = true;       // IMPORTANT for autoplay
      video.playsInline = true;

      // Wait for video to load enough data
      video.onloadeddata = () => {
        // Seek to 1 second (or 0)
        video.currentTime = 0;
      };

      // When seeked to the time
      video.onseeked = () => {
        const canvas = canvasRef.current;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject("Failed to generate thumbnail");
              return;
            }

            // ✅ Convert Blob to File
            const file = new File(
              [blob],
              `video-thumbnail-${Date.now()}.jpg`,
              { type: "image/jpeg" }
            );
            resolve(file);
          },
          "image/jpeg",
          0.85
        );

        URL.revokeObjectURL(url);
      };
    });
  };

  const uploadThumbnail = async (file) => {
    try {
      const generatedThumbnail = await generateThumbnail(file);

      const res = await uploadFile(generatedThumbnail);
      if (res?.data?.success) {
        const coverImageUrl = res?.data?.data?.metadata?.file_url;
        return coverImageUrl;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeVideo = ({ fileList: newVideoList }) => {
    setVideoFile(newVideoList);
  };

  const handleVideoFileUpload = async ({ file, onSuccess, onError }) => {
    const thumbnail = await uploadThumbnail(file);
    try {
      const res = await postVideo(file);

      if (res?.data?.success) {
        const fileUrl = res?.data?.data?.metadata?.file_url;
        handelVideoChange("videoUrl", fileUrl, thumbnail);

        onSuccess(res?.data, file);
      } else {
        throw new Error("Upload failed");
      }
    } catch (e) {
      console.log(e);
      error(e.message || "Upload failed!");
      onError(e);
    }
  };

  const beforeUploadVideo = async (file) => {
    const isMP4 = file.type === "video/mp4";

    if (!isMP4) {
      error("Only MP4 files are allowed!");
      handelVideoChange("videoUrl", null, null);
      setVideoFile([]);
      // return Upload.LIST_IGNORE; // Prevent the file from being added to the list
      return false;
    }

    const isValid = await validateVideoDuration(file);
    if (!isValid) {
      error("Video duration must not exceed 3 minutes!");
      handelVideoChange("videoUrl", null, null);
      setVideoFile([]);
      return false; // OK to keep this for invalid video
    }

    // const previewURL = URL.createObjectURL(file);
    // handelVideoChange("videoUrl", previewURL, thumbnail);

    return true; // Allow the upload
  };

  const validateVideoDuration = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.preload = "metadata";

      // video.onloadedmetadata = () => {
      //     URL.revokeObjectURL(video.src);
      //     resolve(video.duration <= 300); // Check if duration is <= 60 seconds
      // };
      video.onloadedmetadata = () => {
        URL.revokeObjectURL(video.src);
        const duration = video.duration ?? 0;
        const totalSeconds = Math.floor(video.duration);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        handelVideoChange("videoDuration", `${minutes}m ${seconds}s`, null);
        setTimeout(() => resolve(duration <= 300), 0);
      };

      video.onerror = () => {
        error("Unable to load video metadata.");
        resolve(false);
      };

      video.src = URL.createObjectURL(file);
    });
  };

  const handleClear = () => {
    handelVideoChange("videoUrl", null, null);
    setVideoFile([]);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {!videoUrl && (
          <div>
            <Upload
              accept="video/mp4"
              onChange={handleChangeVideo}
              customRequest={handleVideoFileUpload}
              beforeUpload={beforeUploadVideo}
              fileList={videoFile}
              multiple={false}
            >
              <Button type="primary">
                <MdOutlineFileUpload style={{ marginRight: 10 }} />{" "}
                <span>Upload Video</span>
              </Button>
            </Upload>
            <p
              className="form-field-label"
              style={{ color: colorScheme.red, fontSize: 12, marginTop: 3 }}
            >
              Video duration must not exceed 5 minutes!
            </p>
          </div>
        )}

        {videoUrl && (
          <div style={{ marginLeft: "20px", display: "flex" }}>
            <video
              src={videoUrl}
              controls
              width="150"
              style={{ border: "1px solid #ccc", borderRadius: "4px" }}
            />
            <IoIosCloseCircleOutline
              onClick={handleClear}
              style={{ color: "red", fontSize: 20, cursor: "pointer" }}
            />
          </div>
        )}
      </div>

      <video ref={videoRef} style={{ display: "none" }} />
      <canvas ref={canvasRef} style={{ display: "none" }} />
    </>
  );
};

export default CustomVideoUploader;
